import { useLanguage } from "@/lib/LanguageContext";
import { MapPin } from "lucide-react";

const cities = [
  "Boston", "Cambridge", "Somerville", "Medford", "Everett",
  "Malden", "Woburn", "Reading", "Wakefield", "Stoneham",
  "Wilmington", "North Reading",
];

export const ServiceArea = () => {
  const { t } = useLanguage();

  return (
    <section id="area" data-testid="service-area-section" className="py-20 md:py-32 relative overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://images.pexels.com/photos/23963022/pexels-photo-23963022.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)`,
        }}
      />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(5,18,29,0.92), rgba(12,45,72,0.95))' }} />
      <div className="absolute inset-0 noise-overlay" />

      <div className="relative z-10 container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <span className="text-teal text-xs tracking-[0.4em] uppercase font-body font-semibold mb-4 block">
              {t.area.subtitle}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl tracking-wide uppercase font-bold text-white mb-6">
              {t.area.title}
            </h2>
            <div className="w-20 h-[3px] bg-gold mb-8" />
            <p className="font-body text-base text-slate-300 leading-relaxed mb-8">
              {t.area.description}
            </p>
            <p className="font-body text-sm text-slate-400 leading-relaxed">
              {t.area.seoText}
            </p>
          </div>

          {/* Right - Cities Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {cities.map((city, i) => (
              <div
                key={city}
                data-testid={`city-${city.toLowerCase().replace(/\s+/g, '-')}`}
                className="group flex items-center gap-2.5 bg-navy-dark/60 border border-white/5 hover:border-gold/30 px-4 py-3 transition-all duration-300"
              >
                <MapPin className="w-3.5 h-3.5 text-gold flex-shrink-0 group-hover:text-teal transition-colors" strokeWidth={1.5} />
                <span className="font-body text-sm text-slate-300 group-hover:text-white transition-colors">
                  {city}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
